/** Default stale time for CoT events: 5 minutes */
export const DEFAULT_STALE_MS = 5 * 60 * 1000;

/** Polling interval for clients that fall back from WebSocket */
export const POLL_INTERVAL_MS = 5000;

/** Server-side TAK polling interval */
export const TAK_POLL_INTERVAL_MS = 3000;

/** WebSocket ping interval */
export const WS_PING_INTERVAL_MS = 30_000;

/** WebSocket reconnect delay */
export const WS_RECONNECT_DELAY_MS = 2000;

/** Maximum WebSocket reconnect delay (backoff cap) */
export const WS_RECONNECT_MAX_DELAY_MS = 30_000;

/** Contacts polling interval when streaming (no stream equivalent) */
export const TAK_CONTACTS_POLL_INTERVAL_MS = 10_000;

/** Shape backup polling interval when streaming */
export const TAK_SHAPES_POLL_INTERVAL_MS = 30_000;
